import { useParams } from "react-router-dom";

export default function Introduce() {
  const { type } = useParams();
  let content;

  switch (type) {
    case 'summary':
      content =
        <>
          <div className="top__banner top1">
            <div className="tb__text">
              <h1>회사소개</h1>
              <h2>ABOUT US</h2>
            </div>
          </div>
          <div className="nav__wrap">
            <div className="nav__container">
              <div className="nav">
                <div className="mnav">
                  <div className="depth depth1">
                    <span className="">회사소개</span>
                  </div>
                  <div className="depth depth2">
                    <span className="">회사개요</span>
                    <div className="snav">
                      <ul>
                        <li className="on"><a href="summary"><span>회사개요</span></a></li>
                        <li><a href="factory"><span>공장소개</span></a></li>
                        <li><a href="history"><span>연혁</span></a></li>
                        <li><a href="certificate"><span>인증서</span></a></li>
                      </ul>
                    </div>
                  </div>
                </div>
                <div className="loc">
                  <img src="../img/ico/home_icon.png" alt="home" onClick={() => (window.location.href = '/')} className="menuPathBtn" />
                  <span className="arrow"></span>
                  <span className="menuPathBtn" onClick={() => (window.location.href = '/introduce/summary')} >회사소개</span>
                  <span className="arrow"></span>
                  <span>회사개요</span>
                </div>
              </div>
            </div>
          </div>
          <section id="corp_summary">
            <div className="container-1400">
              <div className="contents">
                <div className="content">
                  <div className="sbanner sbanner1">
                    <img src="../img/banner/sbanner1_1.jpg" alt="" />

                    <div className="sb__text">
                      <p>첨단 플랜트 산업 효율 개선 핵심 기업</p>
                      <h3>에이스펙</h3>
                    </div>
                  </div>
                  <div className="summary">
                    <ul>
                      <li>
                        <div className="inner__box sum1">
                          <h3>
                            회사명
                          </h3>
                          <div className="desc">
                            <p>주식회사 에이스펙</p>
                          </div>
                        </div>
                      </li>
                      <li>
                        <div className="inner__box sum2">
                          <h3>
                            대표이사
                          </h3>
                          <div className="desc">
                            <p>김 진 태</p>
                          </div>
                        </div>
                      </li>
                      <li>
                        <div className="inner__box sum3">
                          <h3>
                            업종
                          </h3>
                          <div className="desc">
                            <p>반도체 배관 제작업</p>
                            <p>플랜트 배관 제작업</p>
                            <p>자율주행 기술 연구 용역업</p>
                          </div>
                        </div>
                      </li>
                      <li>
                        <div className="inner__box sum4">
                          <h3>
                            설립일
                          </h3>
                          <div className="desc">
                            <p>2019년 03월 14일</p>
                          </div>
                        </div>
                      </li>
                      <li>
                        <div className="inner__box sum5">
                          <h3>
                            직원
                          </h3>
                          <div className="desc">
                            <p>22명</p>
                            <p>('24년 06월)</p>
                          </div>
                        </div>
                      </li>
                      <li>
                        <div className="inner__box sum6">
                          <h3>
                            주요 고객
                          </h3>
                          <div className="desc">
                            <p>삼성전자, 세방테크,</p>
                            <p>세보엠이씨, 현대자동차,</p>
                            <p>서울대학교</p>
                          </div>
                        </div>
                      </li>
                    </ul>
                  </div>
                </div>
              </div>
            </div>
          </section>
        </>
      break;
    case 'factory':
      content =
        <>

          <div className="top__banner top1">
            <div className="tb__text">
              <h1>회사소개</h1>
              <h2>ABOUT US</h2>
            </div>
          </div>

          <div className="nav__wrap">
            <div className="nav__container">
              <div className="nav">
                <div className="mnav">
                  <div className="depth depth1">
                    <span className="">회사소개</span>
                  </div>
                  <div className="depth depth2">
                    <span className="">공장소개</span>
                    <div className="snav">
                      <ul>
                        <li><a href="summary"><span>회사개요</span></a></li>
                        <li className="on"><a href="factory"><span>공장소개</span></a></li>
                        <li><a href="history"><span>연혁</span></a></li>
                        <li><a href="certificate"><span>인증서</span></a></li>
                      </ul>
                    </div>
                  </div>
                </div>

                <div className="loc">
                  <img src="../img/ico/home_icon.png" alt="home" onClick={() => (window.location.href = '/')} className="menuPathBtn" />
                  <span className="arrow"></span>
                  <span className="menuPathBtn" onClick={() => (window.location.href = '/introduce/summary')}>회사소개</span>
                  <span className="arrow"></span>
                  <span>공장소개</span>
                </div>
              </div>
            </div>
          </div>

          <section id="corp_factory">
            <div className="container-1400">
              <div className="contents">
                <div className="content">
                  <div className="sbanner sbanner2">
                    <img src="../img/banner/sbanner1_2.jpg" alt="" />

                    <div className="sb__text">
                      <h3>주요 생산 인프라</h3>
                      <p>넓은 공간 및 여러 공장으로 자동화 적용</p>
                    </div>
                  </div>

                  <div className="factory">
                    <div className="row">
                      <div className="col img">
                        <img src="../img/corp/intro1.png" alt="" />
                      </div>

                      <div className="col txt">
                        <h3>1공장 <span>(532평)</span></h3>
                        <p className="desc">스테인레스 배관 제작, 클린룸  적용 </p>

                        <p className="addr">충남 당진시 고대면 금암로 389</p>
                      </div>
                    </div>

                    <div className="row">
                      <div className="col img">
                        <img src="../img/corp/intro2.png" alt="" />
                      </div>

                      <div className="col txt">
                        <h3>2공장 <span>(770평)</span></h3>
                        <p className="desc">중형/소형 배관 제작</p>

                        <p className="addr">충남 예산군 고덕면 몽곡2길 57</p>
                      </div>
                    </div>

                    <div className="row">
                      <div className="col img">
                        <img src="../img/corp/intro3.png" alt="" />
                      </div>

                      <div className="col txt">
                        <h3>3공장 <span>(2000평)</span></h3>
                        <p className="desc">대형 배관 및 랙 제작</p>

                        <p className="addr">충남 당진시 우강면 박원로 1</p>
                      </div>
                    </div>

                    <div className="row">
                      <div className="col img">
                        <img src="../img/corp/intro4.png" alt="" />
                      </div>

                      <div className="col txt">
                        <h3>4공장 <span>(800평)</span></h3>
                        <p className="desc">자동화 공장 적용</p>

                        <p className="addr">충남 당진시 순성면 본리로 38-42, 2동</p>
                      </div>
                    </div>

                    <div className="row">
                      <div className="col img">
                        <img src="../img/corp/intro5.png" alt="" />
                      </div>

                      <div className="col txt">
                        <h3>시곡동 연구소</h3>
                        <p className="desc">자동화 공장 개발 및 자율주행 기술연구소</p>

                        <p className="addr">충남 당진시 서해로 6271-12 2층</p>
                      </div>
                    </div>

                    <div className="row last">
                      <div className="col img">
                        <img src="../img/corp/intro6.png" alt="" />
                      </div>

                      <div className="col txt">
                        <h3>슬항리 실험평가실 </h3>
                        <p className="desc">자율주행개발 및 시험평가실</p>

                        <p className="addr">충남 당진시 고대면 금암로 389</p>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </section>

        </>;

      break;
    case 'history':
      content =
        <>
          <div className="top__banner top1">
            <div className="tb__text">
              <h1>회사소개</h1>
              <h2>ABOUT US</h2>
            </div>
          </div>

          <div className="nav__wrap">
            <div className="nav__container">
              <div className="nav">
                <div className="mnav">
                  <div className="depth depth1">
                    <span className="">회사소개</span>
                  </div>
                  <div className="depth depth2">
                    <span className="">연혁</span>
                    <div className="snav">
                      <ul>
                        <li><a href="summary"><span>회사개요</span></a></li>
                        <li><a href="factory"><span>공장소개</span></a></li>
                        <li className="on"><a href="history"><span>연혁</span></a></li>
                        <li><a href="certificate"><span>인증서</span></a></li>
                      </ul>
                    </div>
                  </div>
                </div>

                <div className="loc">
                  <img src="../img/ico/home_icon.png" alt="home" onClick={() => (window.location.href = '/')} className="menuPathBtn" />
                  <span className="arrow"></span>
                  <span className="menuPathBtn" onClick={() => (window.location.href = '/introduce/summary')}>회사소개</span>
                  <span className="arrow"></span>
                  <span>연혁</span>
                </div>
              </div>
            </div>
          </div>

          <section id="corp_history">
            <div className="container-1400">
              <div className="contents">
                <div className="content">
                  <div className="sbanner sbanner1">
                    <img src="../img/banner/sbanner1_3.jpg" alt="" />

                    <div className="sb__text">
                      <h3 className="color__navy">(주)에이스펙 연혁</h3>
                    </div>
                  </div>

                  <div className="history">
                    <ul className="hrow">
                      <li >
                        <ul>
                          <li className="year">2019</li>
                          <li>
                            <strong>03</strong>
                            <span>[주식회사 렙스] 법인 설립</span>
                          </li>
                        </ul>
                      </li>
                      <li >
                        <ul>
                          <li className="year">2020</li>
                          <li>
                            <strong>10</strong>
                            <span>국내 최초 승합 자율주행 차량 제작 및 납품 (솔라티 15인승)</span>
                          </li>
                        </ul>
                      </li>
                      <li >
                        <ul>
                          <li className="year">2021</li>
                          <li>
                            <strong>08</strong>
                            <span>시흥시 자율주행 차량 '마중' 6대 제작 및 납품</span>
                          </li>
                        </ul>
                      </li>
                      <li >
                        <ul>
                          <li className="year">2022</li>
                          <li>
                            <strong>11</strong>
                            <span>자율주행 차량 및 고속자율주행차량(over 160km/h),<br />레이스카 연구/개발 용역 자율주행 전기 버스 제작 및 납품</span>
                          </li>
                        </ul>
                      </li>
                      <li >
                        <ul>
                          <li></li>
                          <li>
                            <strong>11</strong>
                            <span>반도체 배관 관련특허 3건 등록</span>
                          </li>
                        </ul>
                      </li>
                      <li >
                        <ul>
                          <li className="year">2023</li>
                          <li>
                            <strong>10</strong>
                            <span>충남 당진으로 법인 소재지 이전</span>
                          </li>
                        </ul>
                      </li>
                      <li >
                        <ul>
                          <li></li>
                          <li>
                            <strong>11</strong>
                            <span>[주식회사 에이스펙]으로 상호 변경, 업종 추가</span>
                          </li>
                        </ul>
                      </li>
                      <li >
                        <ul>
                          <li></li>
                          <li>
                            <strong>11</strong>
                            <span>자본 증자 (50백만원 → 500백만원)</span>
                          </li>
                        </ul>
                      </li>
                      <li >
                        <ul>
                          <li className="year">2024</li>
                          <li>
                            <strong>01</strong>
                            <span>ISO 9001:2015, ISO 14001:2015 인증</span>
                          </li>
                        </ul>
                      </li>
                      <li >
                        <ul>
                          <li></li>
                          <li>
                            <strong>04</strong>
                            <span>ISO 45001:2018 인증</span>
                          </li>
                        </ul>
                      </li>
                      <li >
                        <ul>
                          <li></li>
                          <li>
                            <strong>04</strong>
                            <span>(주)에이스펙 기업부설연구소 설립</span>
                          </li>
                        </ul>
                      </li>
                      <li >
                        <ul>
                          <li></li>
                          <li>
                            <strong>04</strong>
                            <span>자동화, 용접기 관련 특허 6건 출원</span>
                          </li>
                        </ul>
                      </li>
                      <li >
                        <ul>
                          <li></li>
                          <li>
                            <strong>05</strong>
                            <span>자동화 용접기 특허 1건 출원</span>
                          </li>
                        </ul>
                      </li>
                    </ul>
                  </div>
                </div>
              </div>
            </div>
          </section>
        </>;

      break;
    case 'certificate':
      content =
        <>
          <div className="top__banner top1">
            <div className="tb__text">
              <h1>회사소개</h1>
              <h2>ABOUT US</h2>
            </div>
          </div>

          <div className="nav__wrap">
            <div className="nav__container">
              <div className="nav">
                <div className="mnav">
                  <div className="depth depth1">
                    <span className="">회사소개</span>
                  </div>
                  <div className="depth depth2">
                    <span className="">인증서</span>
                    <div className="snav">
                      <ul>
                        <li><a href="summary"><span>회사개요</span></a></li>
                        <li><a href="factory"><span>공장소개</span></a></li>
                        <li><a href="history"><span>연혁</span></a></li>
                        <li className="on"><a href="certificate"><span>인증서</span></a></li>
                      </ul>
                    </div>
                  </div>
                </div>

                <div className="loc">
                  <img src="../img/ico/home_icon.png" alt="home" onClick={() => (window.location.href = '/')} className="menuPathBtn" />
                  <span className="arrow"></span>
                  <span className="menuPathBtn" onClick={() => (window.location.href = '/introduce/summary')}>회사소개</span>
                  <span className="arrow"></span>
                  <span>인증서</span>
                </div>
              </div>
            </div>
          </div>

          <section id="corp_certificate">
            <div className="container-1400">
              <div className="contents">
                <div className="content">
                  <div className="sbanner sbanner1">
                    <img src="../img/banner/sbanner1_4.jpg" alt="" />

                    <div className="sb__text">
                      <h3 className="color__navy">인증서</h3>
                    </div>
                  </div>

                  <div className="certificate">
                    <div className="certlist">
                      <ul>
                        <li>
                          <div>
                            <img src="../img/corp/cert1.jpg" alt="" />
                            <h3>품질경영시스템 인증서</h3>
                          </div>
                        </li>
                        <li>
                          <div>
                            <img src="../img/corp/cert2.jpg" alt="" />
                            <h3>환경경영시스템 인증서</h3>
                          </div>
                        </li>
                        <li>
                          <div>
                            <img src="../img/corp/cert3.jpg" alt="" />
                            <h3>안전보건경영시스템 인증서</h3>
                          </div>
                        </li>
                        <li>
                          <div>
                            <img src="../img/corp/patent1.png" alt="" />
                            <h3>
                              특허증<br />
                              제 10-2471129 호
                            </h3>
                          </div>
                        </li>
                        <li>
                          <div>
                            <img src="../img/corp/patent2.png" alt="" />
                            <h3>
                              특허증<br />
                              제 10-2471150 호
                            </h3>
                          </div>
                        </li>
                        <li>
                          <div>
                            <img src="../img/corp/patent3.png" alt="" />
                            <h3>
                              특허증<br />
                              제 10-2471134 호
                            </h3>
                          </div>
                        </li>
                        <li>
                          <div>
                            <img src="../img/corp/innobiz.jpg" alt="" />
                            <h3>
                              이노비즈 확인서
                            </h3>
                          </div>
                        </li>
                      </ul>
                    </div>

                    <div className="secure">
                      <div className="secure__item patent">
                        기술특허확보
                      </div>

                      <div className="info">
                        <ul>
                          <li>
                            <div className="secure__item circle nv">
                              <p className="title">특허 수</p>
                              <p className="count">10<span>건</span></p>
                            </div>
                          </li>
                          <li>
                            <div className="secure__item circle gr">
                              <p className="title">등록 수</p>
                              <p className="count">3<span>건</span></p>
                            </div>
                          </li>
                          <li>
                            <div className="secure__item circle gr">
                              <p className="title">출원</p>
                              <p className="count">7<span>건</span></p>
                            </div>
                          </li>
                        </ul>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </section>
        </>
      break;
    default:
      content = <h1>404 Not Found</h1>;
  }

  return (
    <>
      {content}
    </>
  );

}